<template>
  <div>
    <inertia-link
      v-if="!external"
      v-bind="$attrs"
      :preserve-state="preserveState"
      preserve-scroll
      class="flex items-center w-full h-18 text-lg uppercase pl-2 justify-start pr-5"
    >
      <slot />
      <inline-svg
        v-if="active"
        :src="require('@/assets/arrow-down.svg')"
        class="fill-current text-white h-10 ml-auto"
      />
      <inline-svg
        v-else
        :src="require('@/assets/arrow-right.svg')"
        class="fill-current text-white h-10 ml-auto"
      />
    </inertia-link>
    <a
      v-if="external"
      v-bind="$attrs"
      class="flex items-center w-full h-18 text-lg uppercase pl-2 justify-start pr-5"
    >
      <slot />
      <inline-svg
        v-if="active"
        :src="require('@/assets/arrow-down.svg')"
        class="fill-current text-white h-10 ml-auto"
      />
      <inline-svg
        v-else
        :src="require('@/assets/arrow-right.svg')"
        class="fill-current text-white h-10 ml-auto"
      />
    </a>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    preserveState: {
      type: Boolean,
      default: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    external: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
